// accountTourEvents.ts
// Centralizes custom DOM event names used to coordinate account tours.

export const ACCOUNT_BILLING_TOUR_EVENT = 'scribeshadow:accountBillingTour:start';
export const ACCOUNT_BILLING_TOUR_STORAGE_KEY = 'scribeshadow:accountBillingTour:pending';
export const ACCOUNT_SUBSCRIPTION_TOUR_EVENT = 'scribeshadow:accountSubscriptionTour:start';
export const ACCOUNT_SUBSCRIPTION_TOUR_STORAGE_KEY = 'scribeshadow:accountSubscriptionTour:pending';
export const ACCOUNT_SETTINGS_TOUR_EVENT = 'scribeshadow:accountSettingsTour:start';
export const ACCOUNT_SETTINGS_TOUR_STORAGE_KEY = 'scribeshadow:accountSettingsTour:pending';
export const ACCOUNT_PROMO_TOUR_EVENT = 'scribeshadow:accountPromoTour:start';
export const ACCOUNT_PROMO_TOUR_STORAGE_KEY = 'scribeshadow:accountPromoTour:pending';
export const ACCOUNT_REFERRALS_TOUR_EVENT = 'scribeshadow:accountReferralsTour:start';
export const ACCOUNT_REFERRALS_TOUR_STORAGE_KEY = 'scribeshadow:accountReferralsTour:pending';
export const ACCOUNT_GIFTS_TOUR_EVENT = 'scribeshadow:accountGiftsTour:start';
export const ACCOUNT_GIFTS_TOUR_STORAGE_KEY = 'scribeshadow:accountGiftsTour:pending';
